import React from 'react'
import { useParams } from 'react-router-dom'
import blogs from '../../data/blogs'
import Markdown from 'react-markdown'

const Blog = () => {
  const { id } = useParams()
  const blog = blogs.find((b) => b.id === parseInt(id))

  if (!blog) {
    return <h2>Blog not found</h2>
  }

  return (
    <section className="blog section" id="blog">
      <div className="container">
        <h2 className="section-title">{blog.title}</h2>
        <p className="section-subtitle">
          By {blog.author} on {blog.date}
        </p>

        <div className="blog-content">
          <Markdown>{blog.content}</Markdown>
        </div>
      </div>
    </section>
  )
}

export default Blog
